import { render, staticRenderFns } from "./Chartjs.vue?vue&type=template&id=5c239632&"
import script from "./Chartjs.vue?vue&type=script&lang=js&"
export * from "./Chartjs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports